/* Aldodiego 360 — pickup walking times and stores map. Private theme. */
(() => {
  "use strict";
  const root = document.getElementById("ad-shop");
  if (!root || root.dataset.locationsV11Ready) return;
  root.dataset.locationsV11Ready = "true";
  const find = selector => root.querySelector(selector);
  const stores = [
    { name: "Larco", lat: -8.1165318, lng: -79.0311109 },
    { name: "Húsares", lat: -8.1260929, lng: -79.0356240 },
    { name: "El Golf", lat: -8.1380859, lng: -79.0332633 }
  ];
  const geoKey = (root.dataset.geoapifyKey || root.dataset.mapsKey || "").trim();
  const googleDemoKey = (root.dataset.googleMapsDemoKey || "").trim();
  const picker = find("#ad-pickup");
  const deliveryScreen = find('[data-screen="delivery"]');
  const storesScreen = find('[data-screen="stores"]');
  const pickStatus = find("#ad-pickup-status");
  const mapContainer = find("#ad-stores-map");
  const mapStatus = find("#ad-stores-map-status");
  let askedLocation = false, mapPromise = null, googleLoader = null;
  let storesMap = null, storeMarkers = {};
  if (!picker || !deliveryScreen || !storesScreen) return;

  function chooseStore(name) {
    const radio = [...root.querySelectorAll('input[name="ad-store"]')].find(i => i.value === name);
    if (!radio) return;
    if (!radio.checked) radio.click();
    root.querySelectorAll(".ad-pickup-card").forEach(card => {
      const selected = card.dataset.storeName === name;
      card.classList.toggle("is-selected", selected);
      const label = card.querySelector(".ad-pickup-radio-label");
      if (label) label.textContent = selected ? "Tienda seleccionada" : "Seleccionar tienda";
    });
  }

  root.querySelectorAll('input[name="ad-store"]').forEach(radio =>
    radio.addEventListener("change", () => chooseStore(radio.value))
  );
  root.querySelectorAll("[data-pickup-select]").forEach(button =>
    button.addEventListener("click", () => {
      const name = button.dataset.pickupSelect;
      // Switching to pickup uses the original order-mode handler.
      find('[data-method="pickup"]')?.click();
      chooseStore(name);
      // Reuse the existing, tested transition to the product menu.
      find("#ad-start-menu")?.click();
    })
  );
  const search = find("#ad-pickup-search");
  const normalize = value => String(value || "").normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
  if (search) search.addEventListener("input", () => {
    const term = normalize(search.value);
    let matches = 0;
    root.querySelectorAll(".ad-pickup-card").forEach(card => {
      const found = normalize(card.dataset.searchText).includes(term);
      card.hidden = !found;
      if (found) matches++;
    });
    const empty = find("#ad-pickup-empty");
    if (empty) empty.hidden = matches !== 0;
  });
  const checked = find('input[name="ad-store"]:checked');
  if (checked) chooseStore(checked.value);

  const walking = async (from, to, signal) => {
    if (!geoKey) throw new Error("No hay servicio de rutas configurado");
    const url = new URL("https://api.geoapify.com/v1/routing");
    url.searchParams.set("waypoints", from.lat + "," + from.lng + "|" + to.lat + "," + to.lng);
    url.searchParams.set("mode", "walk");
    url.searchParams.set("type", "short");
    url.searchParams.set("units", "metric");
    url.searchParams.set("apiKey", geoKey);
    const response = await fetch(url.toString(), { mode: "cors", signal });
    if (!response.ok) throw new Error("Servicio de rutas temporalmente no disponible");
    const data = await response.json();
    const properties = data?.features?.[0]?.properties;
    const seconds = Number(properties?.time);
    const meters = Number(properties?.distance);
    if (!Number.isFinite(seconds) || seconds <= 0 ||
        !Number.isFinite(meters) || meters < 0) throw new Error("Ruta incompleta");
    return { seconds, meters };
  };

  async function updateWalkingTimes(position) {
    if (!geoKey) {
      pickStatus.textContent = "Puedes elegir cualquiera de las tres tiendas. No pudimos calcular recorridos ahora.";
      return;
    }
    pickStatus.textContent = "Calculando automáticamente los tiempos a pie...";
    const pending = stores.map(async store => {
      const result = await walking(position, { lat: store.lat, lng: store.lng });
      return { name: store.name, ...result };
    });
    const results = await Promise.allSettled(pending);
    const valid = results.filter(r => r.status === "fulfilled").map(r => r.value);
    for (const result of valid) {
      const target = [...root.querySelectorAll("[data-walk-to]")].find(el => el.dataset.walkTo === result.name);
      if (!target) continue;
      const minutes = Math.max(1, Math.ceil(result.seconds / 60));
      const length = result.meters >= 1000 ?
        (result.meters / 1000).toFixed(1).replace(".", ",") + " km" :
        Math.round(result.meters / 10) * 10 + " m";
      target.textContent = minutes + " min a pie · " + length;
      target.hidden = false;
    }
    if (!valid.length) {
      pickStatus.textContent = "No pudimos calcular las rutas a pie. Puedes elegir tu tienda igualmente.";
      return;
    }
    const closest = valid.slice().sort((a, b) => a.seconds - b.seconds)[0];
    const target = [...root.querySelectorAll("[data-walk-to]")].find(el => el.dataset.walkTo === closest.name);
    if (target) target.textContent += " · Más cercana a pie";
    pickStatus.textContent = "Tiempos aproximados desde tu ubicación, calculados por rutas peatonales.";
  }

  function activatePickup() {
    if (!deliveryScreen.classList.contains("is-active") || picker.hidden || askedLocation) return;
    askedLocation = true;
    if (!navigator.geolocation) {
      pickStatus.textContent = "La ubicación no está disponible. Puedes elegir una tienda normalmente.";
      return;
    }
    pickStatus.textContent = "Permite la ubicación para mostrar automáticamente cuánto tardas caminando.";
    navigator.geolocation.getCurrentPosition(
      async position => {
        if (!deliveryScreen.classList.contains("is-active")) return;
        await updateWalkingTimes({ lat: position.coords.latitude, lng: position.coords.longitude });
      },
      () => {
        pickStatus.textContent = "No se compartió la ubicación. Puedes seleccionar cualquier tienda sin calcular el recorrido.";
      },
      { enableHighAccuracy: false, timeout: 12000, maximumAge: 120000 }
    );
  }

  function googleMapsLoaded() {
    return Boolean(window.google && window.google.maps && window.google.maps.Map);
  }
  function ensureGoogle() {
    if (googleMapsLoaded()) return Promise.resolve(window.google.maps);
    if (googleLoader) return googleLoader;
    if (!googleDemoKey) return Promise.reject(new Error("Falta la clave Google Maps de prueba"));
    googleLoader = new Promise((resolve, reject) => {
      const scriptExisting = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
      const success = () => googleMapsLoaded() ? resolve(window.google.maps) :
        reject(new Error("Google Maps aún no está disponible"));
      const failure = () => reject(new Error("No se pudo cargar el mapa"));
      if (scriptExisting) {
        if (googleMapsLoaded()) { success(); return; }
        scriptExisting.addEventListener("load", success, { once: true });
        scriptExisting.addEventListener("error", failure, { once: true });
      } else {
        const cbName = "__ad360StoresMapsReady";
        window[cbName] = success;
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://maps.googleapis.com/maps/api/js?key=" +
          encodeURIComponent(googleDemoKey) +
          "&loading=async&callback=" + cbName + "&v=weekly";
        script.onerror = failure;
        document.head.appendChild(script);
      }
    }).catch(error => { googleLoader = null; throw error; });
    return googleLoader;
  }

  const pinSvg = () => {
    const xml = '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="60" viewBox="0 0 48 60">' +
      '<path d="M24 57C18 48 4 33 4 22a20 20 0 0 1 40 0c0 11-14 26-20 35Z" fill="#B77861" stroke="#FFFFFF" stroke-width="3"/>' +
      '<circle cx="24" cy="22" r="14" fill="#FFF7EE"/>' +
      '<path d="M18 23h12l-6 13-6-13Z" fill="#B77861"/>' +
      '<path d="M16 19a8 8 0 0 1 16 0c0 6-16 6-16 0Z" fill="#B77861"/>' +
      '</svg>';
    return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(xml);
  };

  async function ensureStoresMap() {
    if (!storesScreen.classList.contains("is-active") || !mapContainer) return;
    if (storesMap) return storesMap;
    if (mapPromise) return mapPromise;
    if (!googleDemoKey) {
      mapStatus.textContent = "Selecciona «Cómo llegar» en la tienda que prefieras.";
      return null;
    }
    mapStatus.textContent = "Preparando mapa de los locales...";
    mapPromise = ensureGoogle().then(Google => {
      mapContainer.hidden = false;
      const map = new Google.Map(mapContainer, {
        center: { lat: -8.125, lng: -79.034 }, zoom: 13,
        mapId: "DEMO_MAP_ID",
        disableDefaultUI: true, zoomControl: true,
        clickableIcons: true, gestureHandling: "cooperative"
      });
      const bounds = new Google.LatLngBounds();
      const markerIcon = {
        url: pinSvg(), scaledSize: new Google.Size(44, 55),
        anchor: new Google.Point(22, 52)
      };
      stores.forEach(store => {
        const position = { lat: store.lat, lng: store.lng };
        const marker = new Google.Marker({ map, position, title: "Aldodiego " + store.name, icon: markerIcon });
        marker.addListener("click", () => focusStore(store.name));
        storeMarkers[store.name] = marker;
        bounds.extend(position);
      });
      map.fitBounds(bounds, 55);
      storesMap = map;
      mapStatus.textContent = "Puntos de referencia de nuestras tiendas. Para indicaciones precisas, abre «Cómo llegar».";
      return map;
    }).catch(error => {
      mapContainer.hidden = true;
      mapStatus.textContent = "El mapa no está disponible en esta prueba. Puedes abrir las indicaciones desde cada tienda.";
      console.warn("AD360 mapa de locales:", error);
      return null;
    }).finally(() => { mapPromise = null; });
    return mapPromise;
  }

  function focusStore(name) {
    const item = stores.find(store => store.name === name);
    if (!item || !storesMap) return;
    storesMap.panTo({ lat: item.lat, lng: item.lng });
    storesMap.setZoom(16);
    root.querySelectorAll(".ad-location-v11").forEach(el =>
      el.classList.toggle("is-selected", el.dataset.storeName === name));
  }

  root.querySelectorAll("[data-store-focus]").forEach(button =>
    button.addEventListener("click", async () => {
      const map = await ensureStoresMap();
      if (map) {
        focusStore(button.dataset.storeFocus);
        mapContainer.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        const fallback = [...root.querySelectorAll(".ad-location-v11")].find(
          el => el.dataset.storeName === button.dataset.storeFocus
        );
        fallback?.querySelector('a[href*="maps/dir"]')?.focus();
      }
    })
  );

  const observer = new MutationObserver(() => {
    if (deliveryScreen.classList.contains("is-active")) activatePickup();
    if (storesScreen.classList.contains("is-active")) void ensureStoresMap();
  });
  observer.observe(deliveryScreen, { attributes: true, attributeFilter: ["class"] });
  observer.observe(picker, { attributes: true, attributeFilter: ["hidden"] });
  observer.observe(storesScreen, { attributes: true, attributeFilter: ["class"] });
  activatePickup();
  if (storesScreen.classList.contains("is-active")) void ensureStoresMap();
})();